import { IUserFormInput } from '../types';

const getNonScoredAnswers = (answers: IUserFormInput) => {
  return {
    name: answers['q-101'],
    company: answers['q-102'],
    title: answers['q-103'],
    email: answers['q-104'],
    region: answers['q-201'],
    industry: answers['q-202'],
    helpedByBuS: answers['q-301'] === 'Via Business Sweden',
    yearWithDistributor: answers['q-302'],
    howDidYouFindDistributor: answers['q-301'],
    howManyMarketsDoYouHaveDistributors: answers['q-304'],
    firstMarketExpansion: answers['q-303'],
  };
};

export default getNonScoredAnswers;
